import {
  KABUM_PID,
  KABUM_STG_PID,
  NEWTAILPARTNERBR,
  PICPAY_PID,
  PICPAY_STG_PID,
  RM_TESTES_PUBLISHER,
  TOTALPASS_STG_PID
} from './publisherIds'

export const publisherWithMaxDimensions = [
  KABUM_PID,
  RM_TESTES_PUBLISHER,
  KABUM_STG_PID,
  PICPAY_PID,
  PICPAY_STG_PID,
  NEWTAILPARTNERBR,
  TOTALPASS_STG_PID
]
